import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchUpdateProfile } from "../../../Reducers/actions/userActions";
import { updateUser } from "../../../Reducers/actions/authActions";
import { AuthFormStackSkeleton } from "../../../components/Skeletons/BatchScreenSkeletons";
import { useToast } from "../../../hooks/useToast";
import { setTopNavbar } from "../../../Reducers/actions/navbarActions";
import Icon from "../../../components/Icon/Icon";
import EditProfileV2 from "../../../components/EditProfileV2/EditProfileV2";
import { setHideBottomNav } from "../../../Reducers/actions/navigationActions";

const EditProfileSetting = () => {

    const user = useSelector((state) => state.auth?.user || null);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const toast = useToast()

    useEffect(() => {
        dispatch(setTopNavbar({
            title: "EDIT PROFILE",
            back: true,
        }))

        return () => {
            dispatch(setHideBottomNav(false))
        }
    }, [])

    const handleUpdateProfile = (obj) => {
        setLoading(true)
        fetchUpdateProfile(obj, user.user_id).then(({ success, message, user: newUser }) => {
            if (success) {
                // if (obj.email) {
                //     updateEmail(obj.email).then(res => {
                //         console.log(res, 'RES')
                //     })
                // }
                dispatch(updateUser({ ...user, ...newUser }))
                setLoading(false)
                // navigate("/profile")
            } else {
                toast(message?.length > 0 ? message : "Something went wrong", "danger")
                setLoading(false)
            }
            // setLoading(false)
        })
    }

    if (loading) return (
        <div className="d-flex f-column aic p-16 mt-40 w-full">
            <AuthFormStackSkeleton fields={6} />
        </div>
    )

    return (
        <div className="d-flex f-column aic p-16 mt-40">
            {user ? <EditProfileV2 init_user={user} onSubmit={handleUpdateProfile} showEmail={true} type={"edit"} /> : <AuthFormStackSkeleton fields={6} />}
        </div>
    )
}

export default EditProfileSetting